import ZoneStudio from './ZoneStudio';
import { fiboSequenceMarking } from './fibo-sequence';

export default function ZonePipsPage() {
  return <ZoneStudio mark={fiboSequenceMarking} />;
}
